/** Decimal(14,2) input, matching the Django financial serializers. */
export function normalizeAmount(raw: string): string | null {
  const value = raw.trim().replace(/\s/g, '').replace(',', '.')
  if (!/^\d{1,12}(?:\.\d{1,2})?$/.test(value)) return null
  const [integer, fraction = ''] = value.split('.')
  const cents = BigInt(integer) * 100n + BigInt(fraction.padEnd(2, '0'))
  return cents > 0n ? formatCents(cents) : null
}
export function toCents(value: string): bigint {
  const [integer, fraction = ''] = value.split('.')
  return BigInt(integer) * 100n + BigInt(fraction.padEnd(2, '0'))
}
export function formatCents(value: bigint): string { return `${value / 100n}.${String(value % 100n).padStart(2, '0')}` }
export function sumAmounts(values: string[]): string { return formatCents(values.reduce((total, value) => total + toCents(value), 0n)) }
export function roundRatio(value: bigint, numerator: bigint, denominator: bigint): bigint {
  const product = value * numerator; const whole = product / denominator; const remainder = product % denominator
  return whole + (remainder * 2n > denominator || remainder * 2n === denominator && whole % 2n !== 0n ? 1n : 0n)
}
